import React, { useState, useCallback } from "react";
import { PencilIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
} from "reactstrap";
import { useSnapshot } from "valtio";
import classnames from "classnames";

import { store, setIsAddPeripheralClicked } from "./store";

type DropDownActionProps = {
    setEditedData: (data: any) => void;
    element: { selectedRow: { original: any } };
    setInputIp: (value: boolean) => void;
};

export default function DropDownAction({
    setEditedData,
    element,
    setInputIp,
}: DropDownActionProps) {
    const { t } = useTranslation();
    const { isAddPeripheralClicked } = useSnapshot(store);
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

    const toggle = useCallback(() => setDropdownOpen((prevState) => !prevState), []);

    const handleEdit = useCallback(() => {
        if (!isAddPeripheralClicked) {
            setIsAddPeripheralClicked(true);
        }
        setEditedData(element.selectedRow.original);
        setInputIp(false);
    }, [isAddPeripheralClicked, element, setEditedData, setInputIp]);

    return (
        <div>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="left">
                <DropdownToggle
                    className={classnames("dropdown_custom", {
                        "not-allowed-icon__clz": isAddPeripheralClicked,
                    })}
                    color="white"
                >
                    <VerticalDotsIcon
                        style={{ cursor: "pointer" }}
                        height={25}
                        width={25}
                        fill="black"
                        className="afa_icn_menuPeripheral"
                    />
                </DropdownToggle>
                <DropdownMenu style={{ height: "max-content", left: "-13vh" }}>
                    <DropdownItem
                        className="dropdown-item pl-2"
                        style={{ cursor: "pointer" }}
                        onClick={handleEdit}
                    >
                        <PencilIcon height={15} width={15} />
                        <span className="afa_btn_editPeripheral ml-2">
                            {t("Edit")}
                        </span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    );
}
